import { render, staticRenderFns } from "./Aneel8.vue?vue&type=template&id=bf7d7da2&"
import script from "./Aneel8.vue?vue&type=script&lang=js&"
export * from "./Aneel8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports